import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-f62a02e2"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "banner" };
const _hoisted_2 = { class: "banner-content" };
const _hoisted_3 = { class: "banner-message" };
const _hoisted_4 = ["innerHTML"];
import MaterialIcon from '@/materials/atoms/MaterialIcon.vue';
import { useMessage } from '@/const/messages';
export default /*#__PURE__*/ _defineComponent({
    setup(__props) {
        const { format, STAKING_MENU } = useMessage();
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(MaterialIcon, {
                    icon: "campaign",
                    class: "banner-icon"
                }),
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("span", _hoisted_3, [
                        _createTextVNode(_toDisplayString(_unref(format)(_unref(STAKING_MENU).SCHEDULED_UPDATE_BANNER_MESSAGE)) + " ", 1),
                        _createElementVNode("span", {
                            innerHTML: _unref(format)(_unref(STAKING_MENU).SCHEDULED_UPDATE_BANNER_CHECK_DETAILS)
                        }, null, 8, _hoisted_4)
                    ])
                ])
            ]));
        };
    }
});
